import React from 'react';
import { useParallax } from 'react-scroll-parallax';
import ServicesSection from '../Hero/ServicesSection';
import WelcomeSection from '../Hero/WelcomeSection';
import ConsultationSection from '../Hero/ConsultationSection';
import ImageGallerySection from '../Hero/ImageGallerySection'; // Import the new component
import styles from './HeroSection.module.css';

function HeroSection() {
  const { ref } = useParallax({ speed: -10 });
  
  return (
    <div className={styles.herocontainer}>
      <section className={styles.herosection} ref={ref}>
        {/* <div className="hero-content">
          <h2>Bienvenido a nuestra clínica</h2>
          <p>Ofrecemos servicios de medicina estética de alta calidad</p>
          <button>Más información</button>
        </div> */}
      </section>
      <ServicesSection />
      <WelcomeSection />    
      <ConsultationSection />
      <ImageGallerySection /> {/* Add the new gallery section here */}
    </div>
  );
}

export default HeroSection;